import * as _ from 'underscore';
import { Formatters } from '../../codegen/Localize';
import { CommonStyles } from '../../common/react/CommonStyles';
import { L10n } from '../L10n/L10n';
import { Module } from '../Module';
import { CreatePersonalAccessTokenResult } from '../ServerApi/requests/CreatePersonalAccessTokenRequest';
import { RevokePersonalAccessTokenRequest } from '../ServerApi/requests/RevokePersonalAccessTokenRequest';
import { ServerService } from '../services/ServerService';

// Scope interface used by the controller class.
export interface ICreatePersonalAccessTokenDialogScope extends ng.IScope {
    personalAccessToken: string;
    deleteToken: () => void;
    keepToken: () => void;
    dismiss: () => void;
    close: () => void;
}

export class CreatePersonalAccessTokenDialogCtrl {

  public static $inject = [
    '$scope',
    '$q',
    '$translate',
    'token',
    'ServerService'
  ];

  constructor(
    private $scope: ICreatePersonalAccessTokenDialogScope,
    private $q: ng.IQService,
    private $translate: ng.translate.ITranslateService,
    private token: CreatePersonalAccessTokenResult,
    private serverService: ServerService
  ) {
    $scope.personalAccessToken = token.refreshToken;

    $scope.deleteToken = () => {
      this.serverService.sendRequest(new RevokePersonalAccessTokenRequest({
        refreshToken : token.refreshToken
      })).then(() => {
        $scope.close();
      });
    };

    $scope.keepToken = $scope.dismiss.bind($scope);
  }
}

Module.instance().controller('CreatePersonalAccessTokenDialogCtrl', CreatePersonalAccessTokenDialogCtrl);
